(function($){
    $(function(){
        var $locationList = $('.zn-locations-list');
       
        if ($locationList.length) {
            $locationList.each(function(){
                var $this = $(this),
                    options = {
                        valueNames: [
                            'zn-title',
                            'zn-phone',
                            'zn-address',
                            { data: ['type'] }
                        ]
                    },
                    selectedTypes = [],
                    listID = $this.find('.zn-locations-stage').attr('id'),
                    $filter = $this.find('input[type="checkbox"]'),
                    $list = $('#' + listID).find('ul'),
                    locationList = new List(listID, options),
                    filterList = function() {
                        if (selectedTypes.length) {
                                locationList.filter(function(item){
                                    typeString = item.values().type;
                                    if(typeString){
                                        typeArray = typeString.split(',');

                                        for(var i = 0; i < typeArray.length; i++) {
                                            if (selectedTypes.indexOf(typeArray[i]) >= 0) {
                                                return true;
                                            }
                                        }
                                    }

                                    return false;
                                });
                        } else {
                            locationList.filter();
                        }
                    };

                $filter.on('change', function(){
                    var $this = $(this);
                    if ($this.is(':checked')) {
                        selectedTypes.push($this.val());
                    } else {
                        var index = selectedTypes.indexOf($this.val());
                        if (index > -1) {
                            selectedTypes.splice(index, 1);
                        }
                    }

                    filterList();
                });
            });
        }
    });
})($JQ);